/* eslint-disable no-console */
import { useCallback } from 'react';

const useStoredConversationMessageItem = (
  onUpdate?: (items: { id: string; text: string }[]) => void
) => {
  const load = useCallback((conversationId: string) => {
    if (!conversationId) return '';
    const chats = localStorage.getItem('chats');
    if (!chats) return '';
    const data: { id: string; text: string }[] = JSON.parse(chats);
    const chatItem = data.find(item => item.id === conversationId);
    return chatItem?.text ?? '';
  }, []);

  const clean = useCallback(() => {
    const chats =
      localStorage.getItem('chats') === null
        ? '[]'
        : (localStorage.getItem('chats') as string);
    const data: { id: string; text: string }[] = JSON.parse(chats);
    const filled = data.filter(item => item.text !== '');
    localStorage.setItem('chats', JSON.stringify(filled));
    console.log(
      'after clean',
      JSON.parse(
        localStorage.getItem('chats') === null
          ? '[]'
          : (localStorage.getItem('chats') as string)
      )
    );
  }, []);

  const save = useCallback(
    (conversationId: string, text: string) => {
      if (!conversationId) return;
      const chats =
        localStorage.getItem('chats') === null
          ? '[]'
          : (localStorage.getItem('chats') as string);

      const data: { id: string; text: string }[] = JSON.parse(chats);
      const chatItem = data.find(item => item.id === conversationId);
      if (chatItem) {
        chatItem.text = text;
        localStorage.setItem('chats', JSON.stringify(data));
      } else {
        data.push({ id: conversationId, text });
        localStorage.setItem('chats', JSON.stringify(data));
      }

      console.log(
        'after save',
        JSON.parse(
          localStorage.getItem('chats') === null
            ? '[]'
            : (localStorage.getItem('chats') as string)
        )
      );

      const update: { id: string; text: string }[] = JSON.parse(
        localStorage.getItem('chats') === null
          ? '[]'
          : (localStorage.getItem('chats') as string)
      );
      console.log(update);

      onUpdate?.(update);
    },
    [onUpdate]
  );

  const remove = useCallback(
    (conversationId: string) => {
      if (!conversationId) return;
      const chats = localStorage.getItem('chats');
      if (!chats) return;
      const data: { id: string; text: string }[] = JSON.parse(chats);
      const chatItem = data.find(item => item.id === conversationId);
      if (chatItem) {
        data.splice(data.indexOf(chatItem), 1);
        localStorage.setItem('chats', JSON.stringify(data));
      }
      const update: { id: string; text: string }[] = JSON.parse(
        localStorage.getItem('chats') === null
          ? '[]'
          : (localStorage.getItem('chats') as string)
      );
      console.log(update);

      onUpdate?.(update);
    },
    [onUpdate]
  );

  return { save, load, remove, clean };
};
export { useStoredConversationMessageItem };
